// Copyright (c) Bentley Systems
import { Button, Dialog, Modal } from "@itwin/itwinui-react";
import { SvgCloseSmall } from "@itwin/itwinui-icons-react";
import { LegendHighlight } from "./legend-highlight";
import { getstyleFromString } from "../../Helpers/helper-functions";

export type LegendModalProps = {
  isOpen: boolean;
  onDelete: () => void;
  onCancel: () => void;
  highlights: LegendHighlight[];
};

function getstyle(
  legendHighlight: LegendHighlight,
): import("react").CSSProperties | undefined {
  if (legendHighlight.styleData !== undefined) {
    return getstyleFromString(legendHighlight.styleData);
  }
}

export const LegendModal = (props: LegendModalProps) => {
  const highlightsUi = props.highlights.map((h) => (
    <div key={h.highlightId} className="horizontal">
      <div className="leftAlign" style={getstyle(h)}>
        <div style={{ textAlign: "center", width: 170 }}>
          {h.caption !== null && h.caption !== "" ? h.caption : <wbr />}
        </div>
      </div>
      <div className="rightAlign">
        <div style={{ width: 170 }}>{h.description}</div>
      </div>
    </div>
  ));

  return (
    <Modal
      title="Legend"
      isOpen={props.isOpen}
      isDismissible={false}
      closeOnEsc={true}
    >
      <Dialog.Content>
        <div className="delete-dialog-content" style={{ width: 380 }}>
          {highlightsUi}
        </div>
      </Dialog.Content>
      <Dialog.ButtonBar>
        <Button className="cancel-button" size="small" onClick={props.onCancel}>
          <SvgCloseSmall />
        </Button>
      </Dialog.ButtonBar>
    </Modal>
  );
};
